import React from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

const ICONS = {
  success: CheckCircleRoundedIcon,
  error: ErrorRoundedIcon,
  warning: WarningRoundedIcon,
  info: InfoRoundedIcon,
};

/**
 * The mark at the left of a toast, from the same icon set as the rest of
 * the site. react-toastify's own are fine icons in somebody else's style.
 * Called by the container as a function, not rendered — so no hooks here.
 */
const ToastIcon = ({ type }) => {
  const Icon = ICONS[type] || InfoRoundedIcon;
  return <Icon fontSize="small" />;
};

export default ToastIcon;
